import { Component, Inject, Input, OnInit, OnChanges, EventEmitter, Output } from "@angular/core";
import { DialogService } from "../../../../services/dialog.service";
import { HttpClient } from "@angular/common/http";
import { DefaultValuesService } from "../../../../services/defaultvalues.service";
import { MatDialog } from "@angular/material/dialog";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { MatTableDataSource } from "@angular/material/table";
import { SelectionModel } from "@angular/cdk/collections";
import { KpiDetailFormComponent } from "../../../commondataplatform/kpimanagement/kpidetail-form.component";
import { FilterUtils } from "../../shared-components/filter/filter-utils";

@Component({
    selector: "pe-quarterreporting-list",
    templateUrl: './pe-quarterreporting-list.component.html',
    styleUrls: ['./pe-quarterreporting-list.component.less',
        '../../../../style/new-generic-styles.component.less'],
    standalone: false,
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*', })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ]

})

export class PeQuarterReportingListComponent implements OnInit, OnChanges {
    @Input('list') list: TaxKpiManagement[] = [];
    @Input('filter') filter: string = ''

    @Input('isEditModeEnabled') isEditModeEnabled: boolean = false;
    @Input('isShowAllEnabled') isShowAllEnabled: boolean = false;
    @Input('isReleaseModeEnabled') isReleaseModeEnabled: boolean = false;
    @Input('auxFilterPredicate') auxFilterPredicate!: (filters: string, data: any, parentLevel: boolean, showAllEnabled) => boolean;

    @Input('isRevokeActive') isRevokeActive: boolean = false;
    @Input('isReleaseActive') isReleaseActive: boolean = false;
    @Output() onClickReleaseMode: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() onClickRevokeMode: EventEmitter<boolean> = new EventEmitter<boolean>();

    columnsToDisplay = ['arrow', 'Account', 'KpiName', 'KpiOwner', 'KpiUnit', 'LocalCurrency', 'AvailabilityTime', 'ReportingType', 'actions'];

    public dataSource = new MatTableDataSource<TaxKpiManagement>();

    expandedElements = new Set();
    isAllCollapsed = false;
    Filter = 0;

    Q_current: string;
    Q_1: string;
    Q_2: string;
    Q_3: string;

    updatedItems: TaxKpiManagementUpdate[] = []


    releaseList: selectedReleaseRow[] = []
    selection = new SelectionModel<UserSummary>(true, []);
    constructor(
        private http: HttpClient
        , private dialogService: DialogService
        , private defaults: DefaultValuesService
        , @Inject('BASE_URL') private baseUrl: string
        , private dialogForm: MatDialog

    ) {
        this.Q_current = this.Q_1 = this.Q_2 = this.Q_3 = ''
        this.UpdateQuarterHeader()
    }

    ngOnInit(): void {
        this.dialogService.tthis = this;
        this.dataSource.filterPredicate = (data: TaxKpiManagement, filters: string) => {
            const filterList = filters ? filters.split('+').map(f => f.trim()).filter(f => f) : [];
            filterList.pop();

            if (filterList.length === 0) {
                if (data.subtable) {
                    data.subtable.filter = '__FORCE__';
                } else {
                    this.createMatSubtable(data);
                    data.subtable.filter = '__FORCE__';
                }
                return true;
            }
            
            return FilterUtils.applyCommonFilterLogic(
                data,
                filterList,
                this.dataSource,
                this.auxFilterPredicate.bind(this),
                this.createMatSubtable.bind(this),
                this.isShowAllEnabled
            );
        };
    }

    ngOnChanges(changes: any): void {
        this.UpdateQuarterHeader()
        if (changes.list) {
            this.dataSource.data = this.list;
        }

        this.updatedItems = []

        if (changes.filter) {
            this.dataSource.filter = this.filter;
        }

        if (changes.isReleaseModeEnabled) {
            this.expandedElements.clear();
            this.updatedItems = []
        }
    }

    checkExpanded(element) {
        return this.expandedElements.has(element);
    }

    pushPopElement(element) {
        if (this.expandedElements.has(element)) {
            this.expandedElements.delete(element);
        }
        else {
            this.expandedElements.add(element);
            if (!element.subtable) {
                this.createMatSubtable(element);
            }
        }
    }

    collapseOrExpandAll() {
      if (this.isAllCollapsed === false) {
        this.isAllCollapsed = true;
        this.dataSource.data.forEach(element => {
          if (!this.expandedElements.has(element)) {
            if (!element.subtable)
              this.createMatSubtable(element);
            this.expandedElements.add(element);
          }
        });
      }
      else {
        this.isAllCollapsed = false;
        this.expandedElements.clear()
      }
    }

    accountItemsSelected(ischecked, row) {
        row.KpiDetail.forEach((item) => {
            this.isReleaseActive ? (item.ApprovalStatus == "NEW" ? this.expandedItemSelected(ischecked, item) : null) :
                (item.ApprovalStatus == "RELEASED" ? this.expandedItemSelected(ischecked, item) : null)
        });
    }

    onDetail(element: any) {
        var kpiId = "null"

        if (element.KpiId != undefined) {
            kpiId = element.KpiId
        }

        const dialog = this.dialogForm.open(KpiDetailFormComponent, {
            panelClass: 'custom-mat-dialog',
            disableClose: false,
            data: { "KpiDefinitionId": element.KpiDefinitionId, "KpiId": kpiId, "BusinessLevel": 'PE' }
        });
        dialog.afterClosed().subscribe(result => {
        });
    }

    formatCurrency(value, decimalDigits): string {
        if (value == undefined)
            return '';
        else
            return parseFloat(value).toLocaleString('de', { maximumFractionDigits: decimalDigits });
    }

    onChange(breakdown: any, $e: any, account: any) {
        let pM1 = 0

        if (account.ReportingType == 'YTD') {
            //For YTD kpi type we store difference from previous month 
            if (breakdown.ValueM1 !== undefined)
                pM1 = parseFloat(breakdown.ValueM1);
        }
        let tempObject: TaxKpiManagementUpdate = {
            'KpiId': breakdown.KpiId,
            'KpiDefinitionId': breakdown.KpiDefinitionId,
            'KpiVersion': 'ACTUAL',
            'KpiBreakdown1Id': breakdown.KpiBreakdown1Id,
            'KpiBreakdown2Id': breakdown.KpiBreakdown2Id,
            'KpiMovementTypeId': breakdown.KpiMovementTypeId,
            'KpiProductHierarchyId': breakdown.KpiProductHierarchyId,
            'KpiValue': (parseFloat($e) - (this.defaults.quarterId !== 1 ? pM1 : 0)).toFixed(account.DecimalDigits),
            ApprovalStatus: breakdown.ApprovalStatus,
            KpiUnit: account.KpiUnit,
            DecimalDigits: account.DecimalDigits,
            auxFYFC: '0',
            IsAccumulative: false,
            AccountId: account.AccountID

        }
        this.addUpdatedItem(tempObject);
    }

    disableArrowKeys(event: KeyboardEvent) {
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault();
        }
    }

    accountCheckboxCheck(row) {
        var checked = row.KpiDetail.every((row) => {
            var mappedRow = this.mapReleaseRow(row);
            return this.releaseList.some((object) => this.objectsEqual(mappedRow, object));
        });
        return checked;
    }

    accountItemsIndetermine(row) {
        var indeterminate = this.releaseList.some((selected) => (selected.KpiDefinitionId === row.KpiDefinitionId))
        return indeterminate;
    }

    accountItemsDisable(row) {
        var disable = !row.KpiDetail.some((item) => {
            return (this.isReleaseActive ? (item.ApprovalStatus == "NEW") :
                (item.ApprovalStatus == "RELEASED"))
        }
        )
        return disable;
    }

    expandedItemSelected(ischecked, row) {
        if ((this.isReleaseActive || this.isRevokeActive) && (this.isReleaseActive ? (row.ApprovalStatus == 'NEW') : (row.ApprovalStatus == 'RELEASED'))) {
            var selectedReleaseRow = this.mapReleaseRow(row);
            if (ischecked) {
                this.selection.select(row)
                this.onSelect(selectedReleaseRow);
            } else {
                this.selection.deselect(row)
                this.onDeselect(selectedReleaseRow);
            }
        }

    }

    onClickReleaseMode_emitter() {
        this.onClickReleaseMode.emit();
    }

    onClickRevokeMode_emitter() {
        this.onClickRevokeMode.emit();
    }

    anyActionableItemExist() {
        return this.isReleaseActive ?
            this.list.some((kpi) => kpi.KpiDetail.some((kpidef) => (kpidef.ApprovalStatus == "NEW"))) :
            this.list.some((kpi) => kpi.KpiDetail.some((kpidef) => (kpidef.ApprovalStatus == "RELEASED")))
    }

    textRelRevbuttonState() {
        return this.anyActionableItemExist() ?
            (((this.isReleaseActive || this.isRevokeActive && this.isReleaseActive) ? 'Release ' : 'Revoke ') + (!this.selection.hasValue() ? 'All' : 'Selected')) :
            (this.isReleaseActive ? 'Nothing to Release' : 'Nothing to Revoke')
    }

    getSelectionList() {
        return this.releaseList;
    }

    clearSelectionList() {
        this.releaseList = [];
        this.selection?.clear();
    }

    private createMatSubtable(element: any) {
        let dataSource = new MatTableDataSource<any>();
        dataSource.data = element.KpiDetail;
        dataSource.filterPredicate = (data2: any, filters: string) => {
            return this.auxFilterPredicate(filters, data2, false, this.isShowAllEnabled);
        }
        element.subtable = dataSource;
    }

    private mapReleaseRow(row) {
        var selectedReleaseRow: selectedReleaseRow = {
            KpiDefinitionId: row.KpiDefinitionId,
            KpiMovementTypeId: row.KpiMovementTypeId,
            KpiProductHierarchyId: row.KpiProductHierarchyId,
            KpiBreakdown1Id: row.KpiBreakdown1Id,
            KpiBreakdown2Id: row.KpiBreakdown2Id,
            User: row.User
        };
        return selectedReleaseRow;
    }

    private onSelect(selectedReleaseRow) {
        if (!this.releaseList.some((object) => this.objectsEqual(object, selectedReleaseRow))) {
            this.releaseList.push(selectedReleaseRow)
        }

    }

    private onDeselect(selectedReleaseRow) {
        var mappedRow = this.mapReleaseRow(selectedReleaseRow)
        const index = this.releaseList.findIndex((object) => this.objectsEqual(mappedRow, object));
        if (index !== -1) {
            this.releaseList.splice(index, 1);
        }
    }

    private objectsEqual(object1, object2) {
        if (object1 === object2) {
            return true;
        }
        if (Object.keys(object1).length !== Object.keys(object2).length) {
            return false;
        }
        for (const property in object1) {
            if (object1[property] !== object2[property]) {
                return false;
            }
        }
        return true;
    }

    private addUpdatedItem(newObject: TaxKpiManagementUpdate) {
        const index = this.updatedItems.findIndex(
            (obj) =>
                obj.KpiDefinitionId === newObject.KpiDefinitionId &&
                obj.KpiBreakdown1Id === newObject.KpiBreakdown1Id &&
                obj.KpiBreakdown2Id === newObject.KpiBreakdown2Id &&
                obj.KpiId === newObject.KpiId &&
                obj.KpiVersion === newObject.KpiVersion &&
                obj.KpiMovementTypeId === newObject.KpiMovementTypeId &&
                obj.KpiProductHierarchyId === newObject.KpiProductHierarchyId
        );

        if (index !== -1) {
            if (newObject.KpiValue === 'NaN')
                this.updatedItems.splice(index, 1)
            else
                this.updatedItems[index] = newObject;
        } else {
            this.updatedItems.push(newObject);
        }
    }

    private UpdateQuartersInformation() {

    }

    private UpdateQuarterHeader() {  
       let year = this.defaults.fiscalYear;  
       if (year === -1) {  
           const temp = new Date();  
           year = temp.getFullYear();  
       }  
       const userSelectedQuarter = this.defaults.quarterId;  
       const quarters = ['Q4', 'Q3', 'Q2', 'Q1'];  
       const labels = quarters.slice(4 - userSelectedQuarter!).concat(quarters.slice(0, 4 - userSelectedQuarter!));  

       this.Q_current = `${labels[0]}-${year}`;  
       this.Q_1 = `${labels[1]}-${year - (labels[1] === 'Q4' ? 1 : 0)}`;  
       this.Q_2 = `${labels[2]}-${year - (labels[2] === 'Q4' || labels[2] === 'Q3' ? 1 : 0)}`;  
       this.Q_3 = `${labels[3]}-${year - (labels[3] === 'Q4' || labels[3] === 'Q3' || labels[3] === 'Q2' ? 1 : 0)}`;  
    }
}

export interface SearchItem {
    name: string;
}